"use client";
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { sky_blue } from "../../../../../const/variables";
import { Button } from "@mantine/core";
import { IconDeviceFloppy } from "@tabler/icons-react";
import { repositoryPos } from "../../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../../model/MessageResponse";
import { modals } from "@mantine/modals";

/**
 * In PDF trong chỗ (không mở tab mới). Nếu bị lỗi fetch sẽ fallback sang in HTML.
 */
type Props = {
  pdfUrl?: string;
  autoPrint?: boolean;
  idPrintCreate?: string | number | null;
};
export default function PrintTheTMDT({
  pdfUrl = "https://content.pancake.vn/2-2510/2025/10/9/c15f1873900ab5324d1024821c77663a7418215c.c15f1873900ab5324d1024821c77663a7418215c",
  autoPrint = false,
  idPrintCreate,
}: Props) {
  const fallbackRef = useRef<HTMLDivElement | null>(null);

  const handleReactToPrint = useReactToPrint({
    content: () => fallbackRef.current,
    documentTitle: "Hóa đơn TMĐT",
  } as any);

  // In PDF trong trang hiện tại bằng iframe ẩn
  const printPdfInPlace = async (url: string) => {
    if (!url) {
      console.warn("No pdf url");
      handleReactToPrint();
      return;
    }

    try {
      const res = await fetch(url, { mode: "cors" });
      if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);

      // tạo iframe ẩn
      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      iframe.src = blobUrl;
      document.body.appendChild(iframe);

      // cleanup function dùng chung
      let cleaned = false;
      const cleanup = () => {
        if (cleaned) return;
        cleaned = true;
        try {
          if (document.body.contains(iframe)) document.body.removeChild(iframe);
        } catch (e) {
          /* ignore */
        }
        try {
          URL.revokeObjectURL(blobUrl);
        } catch (e) {
          /* ignore */
        }
        window.removeEventListener("focus", onWindowFocus);
        clearTimeout(fallbackTimer);
      };

      // khi cửa sổ lấy lại focus -> coi như người dùng vừa đóng dialog in -> cleanup
      const onWindowFocus = () => {
        // đợi một chút để chắc chắn dialog đã đóng
        setTimeout(cleanup, 300);
      };
      window.addEventListener("focus", onWindowFocus);

      // hàm thực hiện in, không xóa iframe ngay ở đây
      const tryPrint = () => {
        try {
          iframe.contentWindow?.focus();
          // gọi print trên iframe (nếu trình duyệt cho phép)
          iframe.contentWindow?.print();
        } catch (e) {
          console.warn("Print via iframe failed:", e);
          // fallback sang in HTML
          handleReactToPrint();
          // fallback cleanup sau
          setTimeout(cleanup, 500);
        }
      };

      // onload có thể không fire -> vẫn gọi in sau 600ms
      iframe.onload = () => setTimeout(tryPrint, 600);

      // fallback: nếu không onload trong 2s thì thử in
      const startTimer = setTimeout(() => {
        if (document.body.contains(iframe)) tryPrint();
        clearTimeout(startTimer);
      }, 2000);

      // đảm bảo cleanup sau tối đa 30s (tránh leak nếu user không tương tác)
      const fallbackTimer = setTimeout(() => {
        cleanup();
      }, 30000);
    } catch (err) {
      console.error("❌ Lỗi tải hoặc in PDF:", err);
      // fallback: in HTML
      alert("Không thể in file PDF, đang chuyển sang in bản HTML tạm...");
      handleReactToPrint();
    }
  };

  const handlePrint = async () => {
    // let apiPath = `/api/v1/Ecommerce/print-shipping-document?orderId=${idPrintCreate}&documentType=true`;
    // try {
    //   const response = await repositoryPos.post<MessageResponse<any>>(apiPath);
    //   console.log("response", response);
    //   if (response && response.success) {
    //     const pdfUrlResult = response.data.data[0];
    //     printPdfInPlace(pdfUrlResult);
    //   } else {
    //     NotificationExtension.Fails("In đơn TMĐT thất bại");
    //   }
    // } catch (error) {
    //   console.log("error", error);
    // }
    // in ở chỗ, không mở tab mới
    printPdfInPlace(pdfUrl); //tạm fix cứng vì api đang lỗi trả về rỗng
  };

  React.useEffect(() => {
    if (autoPrint) handlePrint();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Button
      type="button"
      color={sky_blue.deep}
      leftSection={<IconDeviceFloppy size={16} />}
      onClick={() => {
        handlePrint();
        modals.closeAll();
      }}
    >
      In đơn TMĐT
    </Button>
  );
}
